import { createRoot } from "react-dom/client";
import { Routes, Route, Navigate } from "react-router-dom";
import { HistoryRouter } from "redux-first-history/rr6";
import { Provider } from "react-redux";

// Material Dashboard 3 PRO React (MUI v5) theme and UI context
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
import { MaterialUIControllerProvider } from "context";

// core components
import AdminLayout from "./layouts/Admin.js";
import WithRouterProps from "components/DigiHapi/WithRouterProps";

import "assets/css/widgets.css";
import configureStore from "./store/configure-store";
import CookieConsent from "react-cookie-consent";

// import AOS from "aos";
// import "aos/dist/aos.css";
import "app.css";
import AdminLoginPage from "./views/Pages/AdminLoginPage.js";
import ResetPasswordPage from "./views/Pages/ResetPasswordPage.js";
import MaintenancePage from "views/Pages/MaintenancePage.js";

// AOS.init({
//   aos: "flip-left",
//   // disable: "mobile",
//   duration: 2000
// });

const { store, history } = configureStore();

createRoot(document.getElementById("root")).render(
	<Provider store={store}>
		<MaterialUIControllerProvider>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<HistoryRouter history={history}>
					<Routes>
						<Route
							path="/"
							element={<WithRouterProps component={AdminLoginPage} />}
						/>
						<Route
							path="/connexion"
							element={<WithRouterProps component={AdminLoginPage} />}
						/>
						<Route
							path="/reset-password"
							element={<WithRouterProps component={ResetPasswordPage} />}
						/>
						<Route path="/maintenance" element={<MaintenancePage />} />
						<Route path="/team/*" element={<AdminLayout />} />
						<Route path="/webmaster/*" element={<AdminLayout />} />
						<Route path="/admin/*" element={<AdminLayout />} />
						<Route path="*" element={<Navigate to="/" replace />} />
					</Routes>
				</HistoryRouter>
			</ThemeProvider>
		</MaterialUIControllerProvider>
		<CookieConsent
			buttonText="C'est noté"
			// Above the MUI drawer (z-index 1200) and independent of the body font size
			style={{ zIndex: 1400, fontSize: "0.875rem", alignItems: "center" }}
		>
			Nous utilisons des cookies pour vous garantir la meilleure expérience sur
			notre site web. Si vous continuez à utiliser ce site, nous supposerons que
			vous êtes satisfait.
		</CookieConsent>
	</Provider>
);

// document.onreadystatechange = function() {
//   if (document.readyState === "complete") {
//     AOS.refresh();
//   }
// };
